import { createReducer, on } from '@ngrx/store';
import * as ScreeningSettingActions from './screening-settings.actions';
import {ScreeningSettingsDTO} from '../../dto/screening-settings';

export interface ScreeningSettingState {
  settingByProject: { [projectId: number]: ScreeningSettingsDTO };
  loadingByProject: { [projectId: number]: boolean };
  hasSettingByProject: { [projectId: number]: boolean };
  errorByProject: { [projectId: number]: any };

}

export const initialState: ScreeningSettingState = {
  settingByProject: {},
  loadingByProject: {},
  hasSettingByProject: {},
  errorByProject: {},
};

export const screeningSettingReducer = createReducer(
  initialState,

  on(ScreeningSettingActions.loadScreeningSettings, (state, { projectId }) => ({
    ...state,
    loadingByProject: {
      ...state.loadingByProject,
      [projectId]: true,
    },
    errorByProject: {
      ...state.errorByProject,
      [projectId]: null,
    },
  })),

  on(
    ScreeningSettingActions.updateScreeningSettingSuccess,
    ScreeningSettingActions.loadScreeningSettingsSuccess, (state, { projectId, setting }) => ({
    ...state,
    settingByProject: {
      ...state.settingByProject,
      [projectId]: setting,
    },
    loadingByProject: {
      ...state.loadingByProject,
      [projectId]: false,
    },
    hasSettingByProject: {
      ...state.hasSettingByProject,
      [projectId]: true,
    },
  })),

  on(ScreeningSettingActions.loadScreeningSettingsFailure, (state, { projectId, error }) => ({
    ...state,
    loadingByProject: {
      ...state.loadingByProject,
      [projectId]: false,
    },
    errorByProject: {
      ...state.errorByProject,
      [projectId]: error,
    },
    hasSettingByProject: {
      ...state.hasSettingByProject,
      [projectId]: false,
    },
  })),

  on(ScreeningSettingActions.generateScreeningSettingSuccess, (state, { projectId, setting }) => ({
    ...state,
    settingByProject: {
      ...state.settingByProject,
      [projectId]: setting,
    },
    hasSettingByProject: {
      ...state.hasSettingByProject,
      [projectId]: true,
    },
  })),
  on(
    ScreeningSettingActions.generateScreeningSettingFailure,
    ScreeningSettingActions.updateScreeningSettingFailure,
    (state, { projectId, error }) => ({
      ...state,
      errorByProject: {
        ...state.errorByProject,
        [projectId]: error,
      },
    })
  )
);
